import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { LoadingController, AlertController, Platform } from '@ionic/angular';
import { UserService } from 'src/app/services/user.service';
import {Observable, BehaviorSubject, timer, from, throwError, of} from "rxjs";
import moment from 'moment';
import { LocalNotifications } from '@awesome-cordova-plugins/local-notifications/ngx';
import { Insomnia } from '@awesome-cordova-plugins/insomnia/ngx';
import { environment } from '../../environments/environment';

export interface remoteRequestDataIngressStructure {
    key: string,
    value: string,
    email: string,
    createdAt: string,
    updatedAt: string,
    status: string,
  }

@Injectable({ providedIn: 'root' })
export class RequestsService {
    private apiUrl = environment.kilnApi;
    private remoteRequestUrl: string =`${this.apiUrl}/requests`;
  
    public remoteRequestsByExternalId: BehaviorSubject<{ [externalId: string]: remoteRequestDataIngressStructure[] }>
    = new BehaviorSubject<{ [externalId: string]: remoteRequestDataIngressStructure[] }>({});

    public allRemoteRequestsByExternalId: BehaviorSubject<{ [externalId: string]: remoteRequestDataIngressStructure[] }>
    = new BehaviorSubject<{ [externalId: string]: remoteRequestDataIngressStructure[] }>({});
  
    constructor(
      public http: HttpClient,
    ) { }
      
    public populateRemoteRequests(externalId: string) {
        return new Promise((resolve, reject) => {
          this.http.get(`${this.remoteRequestUrl}/${externalId}/pending`).subscribe((remoteRequests) => {
            let current = this.remoteRequestsByExternalId.getValue();
            current[externalId] = remoteRequests as remoteRequestDataIngressStructure[];
            this.remoteRequestsByExternalId.next(current);
            resolve({success: true, function: "populateRemoteRequests"});
          }, (error) => {
            console.log(`BinstLog: Error getting remote requests for externalId ${externalId}. ${JSON.stringify(error)}`)
            reject(error)
          });
        })
    }

    public getAllRequests(externalId: string) {
        return new Promise<{success: boolean, function: string, data: { [externalId: string]: remoteRequestDataIngressStructure[] }}>((resolve, reject) => {
          // Try to get all requests, fallback to pending if endpoint doesn't exist
          this.http.get(`${this.remoteRequestUrl}/${externalId}`).subscribe((remoteRequests) => {
            let current = this.remoteRequestsByExternalId.getValue();
            current[externalId] = remoteRequests as remoteRequestDataIngressStructure[];
            this.allRemoteRequestsByExternalId.next(current);
            resolve({success: true, function: "getAllRequests", data: current});
          }, (error) => {
            // If endpoint doesn't exist, try pending as fallback
            reject({success: false, error: error, function: "getAllRequests", data: {}});
          });
        })
    }
}